module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "chap_no"
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HALL")]), _vm._v(" I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BEGIN IN THE BEGINNING")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a flower that bloomed only in Eden, a flower so glorious it did not need the decoration of leaves. Its color is long gone from the world because it was exiled with me and my beloved.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When he saw me for the first time, as I lay within the verdure of Eden, my Adam plucked a blossom from the leafless stem. He knelt, and with its petals grazed my body.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I sprang to life on a bed of orchids.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Standing facing him, I saw myself through his eyes, and he saw himself through mine, two perfect naked bodies luminous in the light of the first day. Oh, yes, we knew that we were naked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He placed the blossom in my hair, and he moved back, studying me in wonder, as I studied him. Approaching me, he extended his hand toward me, and I extended mine toward his. We longed to touch —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What first?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Our lips longed to connect with —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What first?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He felt his mouth. With moistened fingers he traced my lips, slowly. To share the exquisite sensation aroused, I sketched his lips just as slowly. We parted, only slightly and for an instant, to separate the moment of our first touching from all other moments still to come. Our hands clasped, raised before us. He brought his mouth to my fingers as I brought mine to his. Our hands slipped down, and our lips connected, the first kiss.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_vm._v("Moving back, he lifted the strands of my hair that looped over my")]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v(" breasts. His lips warmed my nipples. I kissed his chest, so lightly furred. Exulting in each awakening, he explored his body and I explored mine. Then eagerly we located on the other the same pleasurable places we had discovered on ourselves.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Easing me back onto the bed of orchids, he bent over me and kissed me from my forehead to my breasts, across my extended arms, back to my breasts, around my nipples, then down, kneeling at my feet, and up again along my legs, between them, lingering at the exquisite opening there. The moisture of his mouth mingled with my own moisture, arousing a warmth that was growing into —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was no word yet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("My lips followed on his body the same path he had traced on mine, down, across his chest, down again, between his legs to his own straining longing.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I raised myself on him. Our lips met again, our bodies pressed together, our arms outstretched, our hands linked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Did I realize then, or only much later, that our lips had drawn on each other a sign of the cross?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What did we feel? What was it, this yearning? Sparks of love — the word was born at that moment! — and desire — our unspoken vocabulary grew! — love and desire, which, in the beginning, were the same. But what was this powerful demand that love and desire were inciting? Fulfilled how?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He located the straining place between his legs as I located the liquid craving between mine. To unite an urgent excitement, our bodies connected the sources of our longing. In amazement, he entered me. In awe, I felt his flushed flesh in me. I clasped it tightly between my legs.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("We became one, asserting that startling fact with each movement of our bodies, separating, but not entirely and only to thrust forth and reunite, again, again, each time deeper. Desire spilled, met each other’s, spilled again, and then again, spilled even more, again, and then it intermingled and became more love, and spilled again.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Joyous at our astonishing discovery, we held hands and knelt in gratitude for this miracle. We faced each other and vowed our union.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Adam and Eve,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Eve and Adam,” he echoed.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("Was it as we lay soon after in each other’s arms that I felt the beginning of a strange stirring, a hint of a long journey beginning? — at the same moment that I saw that there was a shadow in Eden, only")]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v(" one, a shadow created by a tree, its branches contorted, twisted, a tree that had not been there earlier, that had sprouted — I realized this only then — at the moment of our fusion.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "marg"
  }, [_vm._v("No, I cannot begin there, not in the beginning, the first beginning. I should not move too quickly toward intimations of exile. Shall I set another tone for my roaming over time, be immediately defiant in my resurrected challenge?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I did not set out to become the greatest whore of all time!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("My lament is too deep for that tone.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Still, shall I begin with St. John the Divine, who branded me that — the Great Whore of Babylon! — in his book of curses and blessings, his raging Book of Revelation?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I loved him from the moment I first saw him, preaching on a street in the City, that intensely sensual holy man, his taut body barely covered with a swath of hair cloth. I was fifteen, alone, surviving on the streets by stealing. I did not have a name.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("After he had finished preaching, John found me in a darkened street. He claimed he was “choosing” me to be a part of his “holy mission.” I did not ask what that meant, did not even wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I longed for him to cleanse me with his sanctity.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Instead, in a rancid alley, as evening darkened, he bartered with merchants eager to finally taste my body. While strangers ground into me on the dirt, John’s somber presence looked on. Afterwards, he took me with a ferocity I called desire because I knew nothing else.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But I was sure he loved me because, every night while we slept in a squashed room we occupied in one of the City’s many ruins, he held me tenderly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The pattern recurred: In the daytime he preached. At night he sold my body — but I gazed only at him — and then he would take me roughly. One such time with him I clenched dirt and found an ebony stone. Later I sewed the stone onto a headband. On a special occasion I would wear it to please him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I accepted his contradictions just as I accepted, without understanding them, the riddles he spoke about his “holy mission,” especially after he had drunk the wine — sprinkled with dried white powder from crushed mushrooms — that he used to invite visions.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was it madness or despair I saw in his eyes? Once, after he was leading me into the sordid alleys of bodies for sale, he stopped to stare at impoverished wanderers that littered the streets. He uttered in disgust, “To choose to live is to accept decay.”")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He was exiled to the Isle of Patmos by the Emperor, whom he had taunted for “the gross fornications of a dynasty of lust.” I gladly shared John’s exile to the island at the edge of the Aegean Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("On a patch of grass that a clutch of palm trees had kept cool, we removed our clothes and sat on a shawl I had worn, a shawl of ocher and indigo. I held a glass of the powdered wine — I only pretended to sip from it — that John had brought with him, to “celebrate,” he boasted, his exile “from the tyrant emperor.” The glass caught splinters of light from the burnished sunset. I tied the decorated band across my forehead and tilted my head so that, for him, the stone would glint silver and dark in the sun’s stare.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Startled, John gazed at the stone, so intently that he seemed to want to penetrate beyond it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s time,” he said, and turned away harshly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Staring at the red dusk as if it had summoned him, he stood, straining to listen as if to an invisible commanding voice, turning his head at first as if to reject what he heard, then slowly nodding in acceptance. I heard only the agitated murmuring of the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kneeling, John touched the pendant on my forehead. He whispered one word:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mystery.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What mystery do you see, John?” I was afraid, as I had never been before with him. His eyes had turned black.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The most profound mystery,” he extended his riddle. Every sinew of his body strained to form the words he breathed:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“The Mystery of the Whore!. . . Whore!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You forced me to become that!” I challenged the word he hurled at me. “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He spat more mysterious words:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Whore, arrayed in purple and scarlet, decked with gold and precious stones, a golden cup in your hand full of the abominations of your fornications!” He spoke in an astonished voice, as if he did not recognize it as his own.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I tried to embrace him, to soothe his trembling.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He pushed me back and thrust my legs open, holding them that way until I ached and screamed. I tore the band from my forehead and buried it in sand with the stone. He held me like that, a sacrifice, until, with brutal stabs, he forced himself into me over and over, with each stab adding more damnation that seemed commanded beyond the night itself:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mother of whores and of all the abominations of the earth!”")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("His strange words exploded, pieces of his curse scattering like maddened birds about me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With one swift motion of my hand, I attempted angrily to thrust them away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was it then, protesting, that I felt a stirring at once terrifying, at once exciting?")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Shall I begin in Troy?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I stood on a bastion of the City with Paris and Cassandra, his sister — yes, Cassandra was Paris’s sister. Earlier, he had insisted I wear only a diaphanous covering to match his own so that when the breeze of that night kissed our bodies, we would appear, in his words, “even more gloriously naked and look the part for these moments that legend will glorify.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Now he asserted proudly to his sister: “It’s love — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("our")]), _vm._v(" love — and passion” — he touched my arm — “that brought all this heroism about. And it was worth it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cassandra smiled wryly as she looked down at what Paris had indicated, what we stood watching from the highest rampart of the City, the soldiers spilling, almost gracefully, out of the wooden horse.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I knew, of course, that Paris loved — no, desired — only himself. We always made love before a mirror, and I knew on whom his eyes were fixed — not me. Still, that made him a good lover; he carefully prepared his positions.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Lovely Paris —” Cassandra began.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ve told you not to call me ‘lovely,’” Paris said. “That’s a word for a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh, then, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manly")]), _vm._v(" Paris” — Cassandra’s head barely tilted — “your affair with Helen is an excuse.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Paris had stopped listening to her. He rearranged himself to bask in the light of a flaring torch below, its flame flirting with the contours of his face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cassandra turned to me. “Beautiful Helen, have you realized yet how predictable destiny is?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I shook my head, not understanding, not then.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She said, “Your beauty —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And mine —” Paris had heard that.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cassandra spoke her words softly, as she always spoke: “Your beauty, Helen, will be blamed for this.” She pointed to the bleeding bodies below us.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("“My beauty, blamed for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this?")]), _vm._v(" But the reason it all began —”")]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v(" “Helen!” Paris stopped me.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ve known the real reason all along, dear brother,” Cassandra said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How could "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" know?” Paris challenged her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cassandra laughed at the question she was used to hearing.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Paris turned away from his sister’s smile.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It had all begun with the secret he had made me promise to keep after we first made love in Sparta and then sailed on to Troy. That frivolous journey — we were young, aroused by our partnership in beauty — had caused hostile letters between our countries. Words became harsher, accusations grew, reasons for the conflict multiplied and blurred. I had not intended to stay in Troy, nor had I wanted to return to Sparta, to my husband, Menelaus. Just as Paris saw me only as an embellishment to his manly beauty, the King of Sparta had seen me only as a manifestation of his power. In daydreams, I had imagined myself floating . . . where? Anywhere. Away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("will")]), _vm._v(" be held culpab —” I began to accept as we stood on the wall of Troy.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cassandra put a finger to my mouth. “You mustn’t encourage destiny,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Stop that!” Paris reproved his sister’s gesture on my lips. “What if someone saw you and deduced that you and Helen are . . .?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It would confound things terribly, wouldn’t it?” Cassandra still smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I pulled my eyes away from the field of slaughter. I looked beyond the open gate, beyond blood spilling. Smoke of the now burning city rose in whorls of black clouds. Through thickening ashes — as I looked back down at the carnage — a dying soldier stared up at me and shouted:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Whore!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was it then that I felt myself spinning in waves of dislocated memories? Memories that came from —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Where?")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Or shall I begin when, as Salome, I watched from a stairway as Herod’s guards brought John the Baptist in chains to kneel before my mother, Herodias?")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("For nights, from a palace window, I had heard the Baptist hurling his judgments at her from the desert, damning her and the House of Herod as she listened, transfixed, at another window,")]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v(" arousing herself with eager fingers. I saw only his solitary shadow against the blue of night. I tried to imagine to whom such a forceful voice might belong.")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("My imagination could not have envisioned the awesome presence of the man I now saw being led into the palace, his body stripped in an attempt to humiliate him further. He transformed nudity into defiance.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As he passed the corridor where I waited, I stood within light. A swirl of pastel veils sculpted my body, revealing the slenderness of a girl, the fullness of a woman. The Baptist stared at me. Between his chained legs his craving tensed. He turned away, conquering desire.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Soon, I would dance before him and Herod, my flesh licked by the glow of flames twisting violently from a hundred torches that failed to light the gnarled corridors of Herod’s palace.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was it then — no, soon after, when Herod’s rancid voice commanded, “Arouse me with your dance, Salome! Virgin whore!” — that I felt within me an insistent stirring — beginning — striving to connect . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With whom, to what?")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Or shall I begin as Medea?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Challenging the storms that pursued us, I sailed with Jason on the Hellespont. We made love on the Golden Fleece. His hips strained as he pushed against me to enter me still deeper. My legs locked him in me, as he made me vow to remain a barbarian and make him a barbarian. The dark sea heard his demand and my promise.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was it then that my soul prepared to protest what was to come?")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Or shall I begin when, as Magdalene, I knelt with Mary before the crucified figure of Jesus? He looked down at us with anxious love, then gazed at the man who hung from a barren tree on another hill. The stripped bodies of Jesus and Judas twisted toward each other, as they had once before in joy, not pain.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I turned away from my double loss. I had loved them both.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Out of the storming darkness that smothered Calvary, I heard an accusing voice shaped by the wind and — was it possible? — aimed at me. No, at another. Whom!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Was it then that I looked about the site of this atrocity, attempting to locate other presences? Only ghosts? — ghosts stirred from other places, other times?")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Ghosts —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Whose?")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Or shall I begin in Heaven, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("before")]), _vm._v(" the beginning? — before the rebellious flight of angels beyond the boundaries of Heaven, before the War in Heaven spilled into the first garden, into my life as Eve, when the Angel Lucifer and his sister, Cassandra — yes, she was also Lucifer’s sister — descended there to decipher God’s design?")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Or shall I begin when I was Jezebel?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Or when I was —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There are so many lives I’ve lived, so many women I have been, turbulent lives within which — only now — I discover that undefined stirring that recurs in each.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Or is it a demand? — a longing to return to the present, in order to redeem —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What!")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("It should begin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now")]), _vm._v("; in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("present")]), _vm._v(" present, when I am in seclusion in my quarters in the country, within the château of my beloved husband, the handsome Count du Muir, murdered in the Grand Cathedral by his twin brother, Alix, in collusion with their sister, Irena, and perhaps — yes! — the Pope himself.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Before I proceed, I shall assert this: The subject of my many lives will soon become entirely clear; I am committed to the truth; and I am not — repeat, am "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" — a mystic.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I remain in the country for reasons first explained to me by Madame Bernice. She lives down the road, in the château nearest mine. She is, of course, a countess. The source of her enormous wealth is a plantation, located in another country. You shall meet Madame, as I have come to address her; and you shall meet her presently. Trust me. I keep my promises.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How is all that I have claimed possible?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It is.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Can I prove it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I shall provide evidence, reveal details that only truth can yield, of the blossom that grew only in Eden — how else would I know of its existence? — and the exact place where I buried the ebony stone in Patmos. Yes, and I shall allow you to know the secret reason for the Trojan War.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("You shall learn the truth about the seventh veil in my dance before Herod, and of the crucial moment during which the life of John the Baptist would be saved or destroyed. With Jason, we shall ride waves of violence that will recede to expose lies. When we travel to Calvary, I shall describe the intersecting shafts of light within which Jesus died. I shall lead you through the battlefields of the War in Heaven during the eternal moments when the sun was stricken with death and there was darkness — except for one single star.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now")]), _vm._v(" —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Now I shall enlighten you as to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("present")]), _vm._v(" present, my travails as the threatened widow of the noble Count du Muir.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I take you back to the Grand Cathedral.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Embraced by glowing candles, I knelt with my beloved at the foot of the altar where we were to be wed. In hypocritical attitudes of reverence, Alix and Irena bowed their heads in the front pew; the brothers would have been identical, except that my beloved was dark and noble, his brother fair and evil. Several pews behind them sat a presence of elegance, the Contessa, the Count’s mother. Even to these nuptials, she had worn her black "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mantilla")]), _vm._v(" over a dark ivory comb, in perpetual mourning — I had heard gossip — for her lost love, a passionate gypsy from her country.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The nuptials were being officiated by His Holiness himself — a first time — for reasons known only to me and him, and soon to you; I use that undeserved title, “Holiness,” only because it is the accepted form of address for the Pope, not because I think well of him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the Cathedral, hymns of exaltation sung by a hundred choirboys hinted — only hinted — of the bliss the Count and I shared at the prospect of our union. More handsome than ever, just as I was even more beautiful than ever, for him, the Count reached for my hand to place on my finger the ring of our bond.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Irena hissed at Alix: “Kill the whore now!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The word “whore” swirled in terrified echoes — and then in triumph — within the Cathedral. I learned only later, from Madame Bernice, why that occurred.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the Grand Cathedral, Alix stood, a dark object in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dropping the chalice, the Pope scurried away. Young acolytes flung themselves like sacrificial pigeons before the altar.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The burst of Alix’s gun shattered into frightened screams. Over it all, I heard the Contessa’s plaintive protest: “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No!")]), _vm._v(" Don’t murder love!”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("My beloved Count thrust me away, to allow his own body to intercept the fatal missile. It did, and he fell, his spilling blood forming")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v(" a deadly rose about him. He breathed, “I do,” and raised his hand to slip onto my finger the ring I now wear, this amber-tinted diamond.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("As I held my dying love, I was swept by such despair that I did not see nor feel the smoking gun Irena had forced into my hand, did not even hear — though I retained it like a brand — her accusation hurled into the pandemonium in the Cathedral:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("whore")]), _vm._v(" murdered my brother! See! The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("whore")]), _vm._v(" is holding the gun!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In my arms, my beloved gasped his last words:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Save yourself! Flee —” His voice trailed off: “I made preparations —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I pressed my body against his more tightly, refusing.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s the only way I can live now, through you. Stay, and we both die. Flee, and we both live.” Those were his last words.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Redeem true love, my dear!” It was the Contessa, crying out to me as she stood proudly in her pew and echoed her son’s demand to live through me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("To keep him forever alive — and as the Contessa blessed me with her black-teared rosary — I fled the Cathedral, the Pope’s words trailing after me:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Damn the wily whore!”")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b86d045","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_01.vue
// module id = 84
// module chunks = 0